<template>
    <div class="ui text menu quick_action">
        <div class="right menu">
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            $(document).ready(() => {
                $(document).delegate('.quick_link_select .menu .item', 'click', event => {
                    window.location = $(this).data('url')
                })
            })
        },
        computed: {
        },
        methods: {
        }
    }
</script>
